import Dexie, { Table } from 'dexie';
import { UserData } from 'src/types/database-types';

export class MediaHubIndexedDb extends Dexie {
    // All tables are added by dexie when declaring the stores()
    // We just tell the typing system this is the case
    userData!: Table<UserData>;

    constructor() {
        super('media-hub');
        this.version(2).stores({
            userData: 'key,token',
        });
    }
}

export const mediaHubDb = new MediaHubIndexedDb();
